var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgArrowTeam(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M2.66667 2C3.06667 2 3.33333 2.26667 3.33333 2.66667V7.33333C3.33333 8.46667 4.13333 9.33333 5.2 9.33333H11.7333L9.53333 7.13333C9.26667 6.86667 9.26667 6.46667 9.53333 6.2C9.8 5.93333 10.2 5.93333 10.4667 6.2L13.8 9.53333C14.0667 9.8 14.0667 10.2 13.8 10.4667L10.4667 13.8C10.3333 13.9333 10.2 14 10 14C9.8 14 9.66667 13.9333 9.53333 13.8C9.26667 13.5333 9.26667 13.1333 9.53333 12.8667L11.7333 10.6667H5.2C3.46667 10.6667 2 9.2 2 7.33333V2.66667C2 2.26667 2.26667 2 2.66667 2Z",
    fill: "white"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgArrowTeam);
export default __webpack_public_path__ + "static/media/arrow-team.87aee7bb.svg";
export { ForwardRef as ReactComponent };